var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',_vm._b({ref:"cascader",style:({ width: _vm.width }),attrs:{"size":"small","options":_vm.selectOptions,"props":{
    checkStrictly: _vm.multiple,
    value: 'id',
    label: 'name',
    children: 'subs'
  },"filterable":"","clearable":""},on:{"change":_vm.handleChange},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},'el-cascader',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }